<div class="cancel-container">
    <div class="cancel-card">
      <h1>Betaling geannuleerd</h1>
      <p>Er is iets misgegaan tijdens de betaling. Wilt u het opnieuw proberen?</p>
      <button class="primary-button" (click)="retryCheckout()">Opnieuw proberen</button>
    </div>
</div>
